export default __webpack_public_path__ + "static/media/new-order-notification.853f703f.mp3";